import aniImg1 from '@/assets/img/content3/aniImg1.png'
import aniImg2 from '@/assets/img/content3/aniImg2.png'
import aniImg3 from '@/assets/img/content3/aniImg3.png'
import aniImg4 from '@/assets/img/content3/aniImg4.png'
import aniImg5 from '@/assets/img/content3/aniImg5.png'
import enTxt1 from '@/assets/img/content3/enTxt1.png'
import enTxt2 from '@/assets/img/content3/enTxt2.png'
import enTxt3 from '@/assets/img/content3/enTxt3.png'
import enTxt4 from '@/assets/img/content3/enTxt4.png'
import enTxt5 from '@/assets/img/content3/enTxt5.png'

export const navList = [
  {
    id: 3,
    left: -35,
    top: -39,
    aniImg: aniImg1,
    enTxt: enTxt1,
    type: '第一部分',
    title: '爬行动物的演化',
  },
  {
    id: 4,
    left: -13,
    top: -15 ,
    aniImg: aniImg2,
    enTxt: enTxt2,
    type: '第二部分',
    title: '具羽毛恐龙的出现',
  },
  {
    id: 5,
    left: 0,
    top: -37,
    aniImg: aniImg3,
    enTxt: enTxt3,
    type: '第三部分',
    title: '原始基干鸟类',
  },
  {
    id: 6,
    left: -28,
    top: -17,
    aniImg: aniImg4,
    enTxt: enTxt4,
    type: '第四部分',
    title: '反鸟类',
  },
  {
    id: 7,
    left: 0,
    top: -42,
    aniImg: aniImg5,
    enTxt: enTxt5,
    type: '第五部分',
    title: '今鸟型类',
  },
]